import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { ShoppingBag, TrendingUp, Plus } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CrossSellRecommendations = ({ restaurantId, language, onAddItem }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!restaurantId) return;
    const fetchRecs = async () => {
      try {
        const res = await fetch(`${API_URL}/api/recommendations/${restaurantId}`);
        if (res.ok) {
          const d = await res.json();
          setData(d);
        }
      } catch (err) { console.error(err); }
    };
    fetchRecs();
  }, [restaurantId]);

  if (!data || (data.popular.length === 0 && data.cross_sell.length === 0)) return null;

  return (
    <div className="space-y-4">
      {/* Popular Items */}
      {data.popular.length > 0 && (
        <div>
          <h3 className="text-sm font-bold text-[#004E64] flex items-center gap-2 mb-2">
            <TrendingUp className="text-[#FF6B35]" size={16} />
            {language === 'pt' ? 'Mais Populares' : 'Most Popular'}
          </h3>
          <div className="flex gap-3 overflow-x-auto pb-2">
            {data.popular.map((item, i) => (
              <Card key={i} className="rounded-xl min-w-[140px] flex-shrink-0" data-testid={`popular-item-${i}`}>
                <CardContent className="p-3">
                  <p className="text-xs font-semibold text-[#004E64] truncate">{item.name}</p>
                  <div className="flex items-center justify-between mt-1">
                    <span className="text-xs font-bold text-[#FF6B35]">{'\u20AC'}{item.price?.toFixed(2)}</span>
                    <Badge className="bg-[#FF6B35]/10 text-[#FF6B35] text-xs">{item.count}x</Badge>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      )}

      {/* Cross-sell */}
      {data.cross_sell.length > 0 && (
        <div>
          <h3 className="text-sm font-bold text-[#004E64] flex items-center gap-2 mb-2">
            <ShoppingBag className="text-[#2EC4B6]" size={16} />
            {language === 'pt' ? 'Clientes tambem compraram' : 'Customers also bought'}
          </h3>
          <div className="flex gap-3 overflow-x-auto pb-2">
            {data.cross_sell.map((item, i) => (
              <Card key={i} className="rounded-xl min-w-[160px] flex-shrink-0" data-testid={`crosssell-item-${i}`}>
                <CardContent className="p-3">
                  <p className="text-xs font-semibold text-[#004E64] truncate">{item.name}</p>
                  <p className="text-xs text-[#9FA2B4] truncate">{item.restaurant_name}</p>
                  <div className="flex items-center justify-between mt-1">
                    <span className="text-xs font-bold text-[#FF6B35]">{'\u20AC'}{item.price?.toFixed(2)}</span>
                    <Badge className="bg-[#2EC4B6]/10 text-[#2EC4B6] text-xs">{item.count}x</Badge>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CrossSellRecommendations;
